import script from "./CourtScheduleList.vue?vue&type=script&setup=true&lang=js"
export * from "./CourtScheduleList.vue?vue&type=script&setup=true&lang=js"

import "./CourtScheduleList.vue?vue&type=style&index=0&id=548a3565&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-548a3565"]])

export default __exports__